import { Component, Input, OnInit } from '@angular/core';

import { CartState } from '../../api';
import { CrisprCartService } from '../crispr-cart.service';
import { CrisprService } from '../crispr.service';
import { defs } from '../../defs';
import { CatPartBaseDto } from '../../api/catPartBaseDto';

@Component({
	selector: 'narwhalia-crispr-cart-item',
	templateUrl: './crispr-cart-item.component.html',
	styleUrls: ['./crispr-cart-item.component.scss'],
	providers: [CrisprService]
})
export class CrisprCartItemComponent implements OnInit {
	@Input() cartItem: CatPartBaseDto;
	@Input() quantity: number;
	@Input() cartState: CartState;
	digitsInfo = defs.digitsInfo;

	constructor(private crisprCartService: CrisprCartService) {}

	ngOnInit() {}

	addToCart(item: CatPartBaseDto) {
		this.crisprCartService.addItemToCart(item);
	}

	deleteFromCart(item: CatPartBaseDto) {
		this.crisprCartService.deleteItemFromCart(item);
	}
}